import { getErrorReporter } from "./ErrorReporter";

type User = {
  id: string;
  firstName: string;
  lastName: string;
  imposterId?: string;
  permissionRoles: string[];
  organizationId: string;
};
export function setUserInSentry(user: User): void {
  const reporter = getErrorReporter();
  if (!reporter) {
    return;
  }

  reporter.setUser({
    username: `${user.firstName} ${user.lastName}`.trim(),
    id: user.id,
    imposter_id: user.imposterId,
    permissions: user.permissionRoles,
    organization_id: user.organizationId,
  });
}

export function clearUserInSentry(): void {
  const reporter = getErrorReporter();
  if (!reporter) {
    return;
  }
  reporter.setUser(null);
}
